"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _Assignment = _interopRequireDefault(require("../factories/Assignment.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_Assignment.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.PERFORMANCE_QUIZZES_FETCHED] = function performanceQuizzesFetched(state, payload) {
  return state.withMutations(function (newState) {
    payload.assignments.forEach(function (assignment) {
      if (state.get(assignment[0])) return;
      newState.set(assignment[0], new _Assignment.default({
        id: assignment[0],
        attributes: {
          name: assignment[4],
          no_pause: assignment[5],
          end_time: Math.floor(assignment[6] * 1000),
          initial_message: assignment[7],
          hide_review: assignment[8] || null,
          hide_results: assignment[9] || null,
          is_lti: assignment[10] || null,
          deleted: assignment[11] || false
        },
        relationships: {
          creator: {
            data: {
              id: assignment[1]
            }
          },
          question_bank: {
            data: {
              id: assignment[2]
            }
          },
          organization: {
            data: {
              id: assignment[3]
            }
          }
        }
      }));
    });
  });
};
reducers[_constants.ASSIGNMENTS_LIST_FETCHED] = function assignmentListFetch(state, payload) {
  return state.withMutations(function (newState) {
    payload.list.forEach(function (assignment) {
      if (!newState.has(assignment.id)) {
        newState.set(assignment.id, new _Assignment.default({
          id: assignment.id,
          attributes: {
            name: assignment.name,
            deleted: assignment.deleted,
            start_time: assignment.start_time,
            end_time: assignment.end_time,
            finished: assignment.finished,
            class_names: assignment.class_names,
            total_quizzes: assignment.total,
            completed_quizzes: assignment.completed,
            quiz_type: assignment.quiz_type,
            created_at: assignment.created_at,
            hide_results: assignment.hide_results || null,
            hide_review: assignment.hide_review || null,
            is_lti: assignment.is_lti
          },
          relationships: {
            creator: {
              data: {
                id: assignment.creator_id
              }
            },
            question_bank: {
              data: {
                id: assignment.question_bank_id
              }
            },
            organization: {
              data: {
                id: assignment.organization_id
              }
            },
            exam_template: {
              data: {
                id: assignment.exam_template_id
              }
            }
          }
        }));
      }
    });
  });
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.QUIZ_FETCHED_PERFORMANCE] = stateHelper.set;
reducers[_constants.QUIZ_FETCHED_TAKE] = stateHelper.set;
reducers[_constants.QUIZZES_FETCHED] = stateHelper.set;
reducers[_constants.ASSIGNMENT_FETCHED] = stateHelper.set;
reducers[_constants.ASSIGNMENT_CREATED] = function (state, payload) {
  var _payload$data$attribu = payload.data.attributes,
    startTime = _payload$data$attribu.start_time,
    totalAssignees = _payload$data$attribu.total_assignees;
  // Reference total assignees while the quizzes are generated in the backend. SendLater assignments will still show 0 quizzes until their scheduled start
  if (new Date(startTime) < new Date()) {
    payload.data.attributes.total_quizzes = totalAssignees;
  }
  return stateHelper.set(state, payload);
};
reducers[_constants.ASSIGNMENT_UPDATED] = function (state, payload) {
  var _payload$data$attribu2 = payload.data.attributes,
    startTime = _payload$data$attribu2.start_time,
    totalAssignees = _payload$data$attribu2.total_assignees;
  if (new Date(startTime) < new Date()) {
    payload.data.attributes.total_quizzes = totalAssignees;
  }
  return stateHelper.set(state, payload);
};
reducers[_constants.ASSIGNMENT_MESSAGE_CREATED] = stateHelper.set;
// When loading Assignments for the B2B Admin Tools we mark
reducers[_constants.ASSIGNMENTS_FETCHED] = function (state, payload) {
  payload.data.forEach(function (record) {
    record.attributes.assigned_to_current_user = state.getIn([parseInt(record.id), 'assigned_to_current_user'], false);
  });
  return stateHelper.set(state, payload);
};
// The User may have assignments assigned to them so when we select an Organization we don't do a full reset.
// Instead we filter out any assignments which aren't assigned to the current user (set in reducer above).
reducers[_constants.ORGANIZATION_SELECTED] = function (state) {
  return state.filter(function (assignment) {
    return assignment.get('assigned_to_current_user');
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);